export default "__VITE_ASSET__44d825cf__";